<div class="pb-4" [class.d-none]="isShowcasesLoading || isWidgetsLoading"
     [attr.aria-busy]="(isShowcasesLoading || isWidgetsLoading)"
     data-automation-id="frc-showcases-wrapper">
  <div *ngFor="let frcShowcase of frcShowcases; trackBy: trackByShowcaseType;"
       [attr.data-automation-id]="'showcase-' + frcShowcase.type">
    <section class="container-fluid p-0" [ngSwitch]="frcShowcase.type">
      <div class="frc-showcase-container px-3 mx-0 my-3"
           *ngSwitchCase="showcasesTypes.CONTRIBUTORS">
        <app-contributors
          [entity]="entity"
          [contributors]="frcShowcase.showcase?.data"
          [totalCount]="frcShowcase.showcase?.totalCount"
          [isLoading]="isContributorsLoading"
          [identifier]="frcShowcase.showcase?.identifier"
          [showcaseId]="frcShowcase.showcase?.showcaseId"
          (loadMore)="loadMore($event)">
        </app-contributors>
      </div>

      <div class="frc-showcase-container px-3 mx-0 my-3"
           *ngSwitchCase="(frcShowcase.showcase?.type === showcasesTypes.TOPICS
              || (frcShowcase.showcase?.type === showcasesTypes.CUSTOM && frcShowcase.showcase?.isMultiple))
              ? frcShowcase.type : '' ">
        <app-multiple-showcases-view
          [entity]="entity"
          [showcaseId]="frcShowcase.showcase?.showcaseId"
          [showcases]="frcShowcase.showcase?.data"
          [totalCount]="frcShowcase.showcase?.totalCount"
          [showcaseType]="frcShowcase.showcase?.type">
        </app-multiple-showcases-view>
      </div>

      <div class="frc-showcase-container px-3 mx-0 my-3"
           *ngSwitchCase="showcasesTypes.NYT">
        <app-nyt-showcase-view
          [showcaseType]="frcShowcase.showcase?.type"
          [name]="frcShowcase.showcase?.name"
          [entity]="entity"
          [identifier]="frcShowcase.showcase?.identifier"
          [showcaseId]="frcShowcase.showcase?.showcaseId"
          [resources]="frcShowcase.showcase?.data"
          [totalCount]="frcShowcase.showcase?.totalCount">
        </app-nyt-showcase-view>
      </div>

      <div class="frc-showcase-container px-3 mx-0 my-3"
           *ngSwitchCase="(frcShowcase.showcase?.type === showcasesTypes.RESOURCES
              || (frcShowcase.showcase?.type === showcasesTypes.CUSTOM && !frcShowcase.showcase?.isMultiple))
              ? frcShowcase.type : '' ">
        <app-single-showcase-view
          [showcaseType]="frcShowcase.showcase?.type"
          [entity]="entity"
          [identifier]="frcShowcase.showcase?.identifier"
          [showcaseId]="frcShowcase.showcase?.showcaseId"
          [resources]="frcShowcase.showcase?.data"
          [totalCount]="frcShowcase.showcase?.totalCount"
          [metadata]="frcShowcase.showcase?.metadata">
        </app-single-showcase-view>
      </div>

      <div *ngSwitchCase="syndeticsWidget.series" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" data-automation-id="unbound-series-container"
           [class.d-none]="!insertWidgetsStatus.series || !displaySettings.series">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <fa-icon [icon]="booksIcon" class="mr-3 books-icon"></fa-icon>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-series-title">unboundMoreInThisSeries</h3>
        </div>
        <div class="unbound_series px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.patronreviews" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.patronreviews || !displaySettings.patronreviews" data-automation-id="unbound-reader-reviews-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-reader-reviews-title">unboundReaderReviews</h3>
        </div>
        <div class="unbound_patronreviews px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.similar" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.similar || !displaySettings.similar" data-automation-id="unbound-similar-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-similar-title">unboundYouMayAlsoLike</h3>
        </div>
        <div class="unbound_similar px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.reviews" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.reviews || !displaySettings.reviews" data-automation-id="unbound-prof-reviews-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-prof-reviews-title">unboundProfessionalReviews</h3>
        </div>
        <div class="unbound_reviews px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.bookprofile" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.bookprofile || !displaySettings.bookprofile" data-automation-id="unbound-bookprofile-container">
        <div class="d-flex align-items-center ml-2 mt-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" data-automation-id="unbound-bookprofile-title" translate>unboundBookProfile</h3>
        </div>
        <div class="unbound_bookprofile mx-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.readinglevel" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.readinglevel || !displaySettings.readinglevel" data-automation-id="unbound-reading-level-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-reading-level-title">unboundReadingLevel</h3>
        </div>
        <div class="unbound_readinglevel px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.awards" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.awards || !displaySettings.awards" data-automation-id="unbound-awards-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-awards-title">unboundAwards</h3>
        </div>
        <div class="unbound_awards px-4 px-sm-17"></div>
      </div>

      <div *ngSwitchCase="syndeticsWidget.author" class="frc-showcase-container unbound-container p-0 px-sm-3 mx-0 my-3" [class.d-none]="!insertWidgetsStatus.author || !displaySettings.author" data-automation-id="unbound-about-the-author-container">
        <div class="d-flex align-items-center ml-4 ml-sm-2 mt-4 mt-sm-5">
          <span class="icon-related-resources"></span>
          <h3 class="unbound-title m-0" translate data-automation-id="unbound-about-the-author-title">unboundAboutTheAuthor</h3>
        </div>
        <div class="unbound_author px-4 px-sm-17"></div>
        <div class="mb-4 mt-3 px-4 px-sm-17">
          <a [routerLink]="['/search', 'card']"
             [queryParams]="{id: entity.agentId, entityType: entityTypes.AGENT}"
             data-automation-id="unbound-about-the-author-see-more"
             class="unbound-author-see-more"
             translate>
            unboundSeeMoreByThisAuthor</a>
        </div>
      </div>
    </section>
  </div>
</div>

<div *ngIf="isShowcasesLoading || isWidgetsLoading" data-automation-id="showcase-page-loading-spinner" class="row justify-content-center">
  <div class="spinner-border text-primary loader-spinner" role="status" aria-live="polite">
      <span class="sr-only" translate>
        Loading...
      </span>
  </div>
</div>
